// extracted by mini-css-extract-plugin
export default {"BackAddBU":"prompts_BackAddBU__lm6qj","CustomTitle":"prompts_CustomTitle__MX6Jb","ModalCloseBU":"prompts_ModalCloseBU__LzLkr","AddPromptBU":"prompts_AddPromptBU__jOF-E"};